import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import CardListPage from 'views/contact/List';
import SupervisorReview from 'views/supervisor-review';
import Session from 'views/calendar/session';
import AssessmentsPage from 'views/asessments';
import GoalsPage from 'views/asessments/GoalsPage';
import ProviderIntake from 'views/provider-intake/index';
import Contracts from 'views/contracts/index';
import SignContract from 'views/contracts/SignContract';

// sample page routing
// const HomePage = Loadable(lazy(() => import('views/home')));
const AttendancePage = Loadable(lazy(() => import('views/attendance')));
const CalendarPage = Loadable(lazy(() => import('views/calendar')));
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/ResetPassword3')));

// ==============================|| MAIN ROUTING ||============================== //

const hasAdminRole = localStorage.roles?.includes('Admin');
const hasSupervisorRole = localStorage.roles?.includes('Supervisor');

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <AttendancePage />
        },
        {
            path: '/calendar',
            element: <CalendarPage />
        },
        {
            path: '/session/:sessionId',
            element: <Session />
        },
        {
            path: '/attendance',
            element: <AttendancePage />
        },
        {
            path: '/lesson-library',
            element: <CardListPage />
        },
        {
            path: '/assessments',
            element: <AssessmentsPage />
        },
        {
            path: '/assessment',
            element: <GoalsPage />
        },
        hasSupervisorRole
            ? {
                  path: '/supervisor-review',
                  element: <SupervisorReview />
              }
            : null,
        hasSupervisorRole || hasAdminRole
            ? {
                  path: '/provider-intake',
                  element: <ProviderIntake />
              }
            : null,
        !hasAdminRole
            ? {
                  path: '/contracts',
                  element: <Contracts />
              }
            : null,
        !hasAdminRole
            ? {
                  path: '/contracts/:sessionid',
                  element: <SignContract />
              }
            : null,
        {
            path: '/reset-password',
            element: <AuthResetPassword />
        }
    ].filter(Boolean)
};

export default MainRoutes;
